import { removeItemFromArray, removeKeyFromState } from '../../util/reducers'
import {
  CLEAR_ALL_TYPING_INDICATORS,
  SET_ACTIVE,
  SET_INACTIVE,
} from './actions'

export function actives(state = {}, action) {
  switch (action.type) {
    case SET_ACTIVE:
      return setActive(state, action)
    case SET_INACTIVE:
      return setInactive(state, action)
    case CLEAR_ALL_TYPING_INDICATORS:
      return clearAllTypingIndicators(state)
    default:
      return state
  }
}

function setActive(state, action) {
  const activeLookup = action.activeLookup

  if (action.isAFetchAll) {
    return activeLookup
  } else {
    Object.keys(activeLookup).forEach((model) => {
      if (Array.isArray(activeLookup[model])) {
        state = concatActivesForModel(state, model, activeLookup)
      } else {
        state = indexActivesByAssociatedModel(state, model, activeLookup)
      }
    })
    return state
  }
}

function setInactive(state, action) {
  const inactiveLookup = action.inactiveLookup
  return loopThroughObject(state, inactiveLookup)
}

function concatActivesForModel(state, model, activeLookup) {
  return {
    ...state,
    [model]: [...new Set([...(state[model] || []), ...activeLookup[model]])],
  }
}

function indexActivesByAssociatedModel(state, model, activeLookup) {
  Object.keys(activeLookup[model]).forEach((associatedModel) => {
    Object.keys(activeLookup[model][associatedModel]).forEach((id) => {
      const stateAssociatedModel = state[model] && state[model][associatedModel]
      const stateId = stateAssociatedModel && stateAssociatedModel[id]
      if (
        stateId &&
        stateId.includes(activeLookup[model][associatedModel][id][0])
      )
        return state

      state = {
        ...state,
        [model]: {
          ...state[model],
          [associatedModel]: {
            ...stateAssociatedModel,
            [id]: [
              ...(stateId ? stateId : []),
              ...activeLookup[model][associatedModel][id],
            ],
          },
        },
      }
    })
  })
  return state
}

function loopThroughObject(state, change) {
  Object.keys(change).forEach((key) => {
    const childState = state[key]
    const childChange = change[key]
    if (!childState) return state
    if (hasDifferentStructure(childState, childChange)) {
      throw 'active change has different structure to state'
    }

    if (Array.isArray(childState)) {
      const newChildState = loopThroughLeafNode(childState, childChange)
      if (newChildState.length) {
        state = {
          ...state,
          [key]: newChildState,
        }
      } else {
        state = removeKeyFromState(state, key)
      }
    } else {
      const newChildState = loopThroughObject(childState, childChange)
      if (Object.keys(newChildState).length) {
        state = {
          ...state,
          [key]: newChildState,
        }
      } else {
        state = removeKeyFromState(state, key)
      }
    }
  })
  return state
}

function loopThroughLeafNode(activeArrayState, activeArrayChange) {
  activeArrayChange.forEach((activeIdToRemove) => {
    const index = activeArrayState.indexOf(activeIdToRemove)
    if (index >= 0) {
      activeArrayState = removeItemFromArray(activeArrayState, index)
    }
  })
  return activeArrayState
}

function hasDifferentStructure(state, change) {
  const isStateArray = Array.isArray(state)
  const isChangeArray = Array.isArray(change)
  return (isStateArray && !isChangeArray) || (!isStateArray && isChangeArray)
}

const clearAllTypingIndicators = (state) => {
  const { typing, ...newState } = state
  return newState
}
